import { Grid } from '@material-ui/core';
import React from 'react';
import Engagement from '../common/Engagement';
import SkillsProgress from '../common/SkillsProgress';
import OverallCards from '../common/OverallCards';
import Overview from './Overview';
import { ReportEntityType } from 'components/ReportsModule/types';
import useSkillProgress from '../hooks/use-skill-progress';
import useDistrictEngagement from '../hooks/use-district-engagement';
import useDistrictOverview from '../hooks/use-district-overview';

const PrmDistrict = () => {
  const [
    {
      setList,
      selectedProductCurriculumId: skillProgressCurriculumId,
      prmCurriculumProgressReport,
      curriculumLessonReport,
      curriculumProgressLoading,
      curriculumLessonLoading
    },
    { setSelectedProductCurriculumId: setSkillProgressCurriculumId }
  ] = useSkillProgress();

  const [
    { organizationCurriculumProgress, productCurriculumId: selectedEngagementId, loading },
    { setProductCurriculumId: setEngagementId }
  ] = useDistrictEngagement();
  const [{ prmOrganizationEngagementOverviewReport }] = useDistrictOverview();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <OverallCards
          prmCurriculumProgressReport={prmCurriculumProgressReport}
          progressLoading={curriculumProgressLoading}
        />
      </Grid>
      <Grid item xs={12}>
        <SkillsProgress
          curriculumLessonReport={curriculumLessonReport!}
          entityType={ReportEntityType.DISTRICT}
          selected={skillProgressCurriculumId}
          setSelected={setSkillProgressCurriculumId}
          setList={setList}
          loading={curriculumLessonLoading!}
        />
      </Grid>
      <Grid item xs={12}>
        <Engagement
          setList={setList!}
          organizationCurriculumProgress={organizationCurriculumProgress}
          selectedId={selectedEngagementId!}
          setId={setEngagementId}
          loading={curriculumLessonLoading || loading}
        />
      </Grid>
      <Grid item xs={12}>
        <Overview
          prmOrganizationEngagementOverviewReport={prmOrganizationEngagementOverviewReport as any}
        />
      </Grid>
    </Grid>
  );
};

export default PrmDistrict;
